export const VALIDATION_ERROR_MESSAGES = {
    ADDRESS: 'ssap.validation_error_message.valid_address',
    ALIEN_NUMBER: 'ssap.validation_error_message.alien_number',
    ALL_QUESTIONS: 'ssap.validation_error_message.all_questions',
    AMOUNT_LESS: 'ssap.validation_error_message.amount_less',
    ANY_CERTIFICATE: 'ssap.validation_error_message.any_certificate',
    ANY_VALUE: 'ssap.validation_error_message.any_answer',
    APPLICANT_ENROLLED: 'ssap.validation_error_message.applicant_enrolled',
    AT_LEAST_ONE_APPLICANT_ENROLLED: 'ssap.validation_error_message.at_least_one_applicant_enrolled',
    BOTH_NAMES: 'ssap.validation_error_message.both_names',
    CERTIFICATE_NUMBER: 'ssap.validation_error_message.certificate_number',
    CITIZENSHIP_NUMBER: 'ssap.validation_error_message.citizenship_number',
    CHECKED: 'ssap.validation_error_message.checked',
    CHIP_DENIAL: 'ssap.validation_error_message.chip_denial',
    CHILD_PARENT_AGE_MATCH: 'ssap.validation_error_message.child_parent_age_match',
    CHOOSE_DELIVERY_CHANNEL: 'ssap.validation_error_message.choose_delivery_channel',
    CHOSEN: 'ssap.validation_error_message.chosen',
    COUNTRY_OF_ISSUANCE: 'ssap.validation_error_message.country',
    COVERAGE_TYPE: 'ssap.validation_error_message.type_of_coverage',
    CITY: 'ssap.validation_error_message.city',
    DATE: 'ssap.validation_error_message.date',
    DATE_NOT_AFTER_START: 'ssap.validation_error_message.date_not_after_start',
    DECEASED_DATE_NOT_FUTURE_DATE: 'ssap.validation_error_message.death_date_non_future_date',
    DEDUCTION_SOURCE: 'ssap.validation_error_message.deduction_source',
    DEFINE_TAX_FILERS: 'ssap.validation_error_message.tax_filers',
    DOC_DESCRIPTION: 'ssap.validation_error_message.doc_description',
    DOCUMENT_TYPE: 'ssap.validation_error_message.document_type',
    DOLLAR: 'ssap.validation_error_message.dollar_value',
    EDUCATION_EXPENSES: 'ssap.validation_error_message.education_expenses',
    EMAIL: 'ssap.validation_error_message.email',
    EMPLOYER: 'ssap.validation_error_message.employer',
    EMPLOYER_HRA: 'ssap.validation_error_message.employer_hra',
    EMPLOYER_NAME: 'ssap.validation_error_message.employer_name',
    I_551: 'ssap.validation_error_message.i_551',
    I_94: 'ssap.validation_error_message.i_94',
    INCOME_SOURCE: 'ssap.validation_error_message.income_source',
    INCORRECT_SSN: 'ssap.validation_error_message.incorrect_ssn',
    INVALID_CHARS: 'ssap.validation_error_message.invalid_chars',
    INVALID_DATE_OR_NOT_AFTER_START: 'ssap.validation_error_message.invalid_date_or_not_after_start',
    FIRST_NAME: 'ssap.validation_error_message.first_name',
    PRIMARY_TAX_FILER: 'ssap.validation_error_message.primary_tax_filer',
    LAST_NAME: 'ssap.validation_error_message.last_name',
    LENGTH: 'ssap.validation_error_message.length',
    MAKE_SELECTION: 'ssap.validation_error_message.make_selection',
    MEDICAID_TERMINATION: 'ssap.validation_error_message.medicaid_termination',
    MIDDLE_NAME: 'ssap.validation_error_message.middle_name',
    MONEY: 'ssap.validation_error_message.money',
    NAME: 'ssap.validation_error_message.name',
    NATURALIZATION_NUMBER: 'ssap.validation_error_message.naturalization_number',
    NOBODY_LIVES_IN_STATE: 'ssap.validation_error_message.nobody_lives_in_state',
    NOT_EMPTY: 'ssap.validation_error_message.not_empty',
    NOT_UNIQUE_SSN: 'ssap.validation_error_message.not_unique_ssn',
    OTHER_RACE_OR_ETHNICITY: 'ssap.validation_error_message.other_race_or_ethnicity',
    PASSPORT: 'ssap.validation_error_message.passport',
    PHONE_EXTENSION: 'ssap.validation_error_message.phone_extension',
    PHONE_NUMBER: 'ssap.validation_error_message.phone_number',
    PROVIDE_SPOUSE: 'ssap.validation_error_message.add_spouse',
    RACES_QTY_EXCEEDING: 'ssap.validation_error_message.races_qty_exceeding',
    RANGE: 'ssap.validation_error_message.range',
    RANGE_UP_TO_7: 'ssap.validation_error_message.range_up_to_7',
    RANGE_UP_TO_19: 'ssap.validation_error_message.digits_up_to_nineteen',
    RANGE_UP_TO_168: 'ssap.validation_error_message.range_up_to_168',
    REPRESENTATIVE_ORGANIZATION_NAME: 'ssap.validation_error_message.representative_organization_name',
    REPRESENTATIVE_ORGANIZATION_ID: 'ssap.validation_error_message.representative_organization_id',
    SIGNATURE: 'ssap.validation_error_message.signature',
    SEVIS_ID: 'ssap.validation_error_message.savis_id',
    SPECIFIED: 'ssap.validation_error_message.specified',
    SSN: 'ssap.validation_error_message.ssn',
    UNIQUE_SSN: 'ssap.validation_error_message.unique_ssn',
    UPDATE_INFO: 'ssap.validation_error_message.please_update_info',
    UPDATE_INFORMATION: 'ssap.validation_error_message.update_info',
    VISA: 'ssap.validation_error_message.visa',
    ZIP: 'ssap.validation_error_message.zip',
    ZIP_5_DIGITS: 'ssap.validation_error_message.zip_5_digits'
};